// extracted by mini-css-extract-plugin
export var shake = "_1u-0";